export default __webpack_public_path__ + "static/media/profile-icon-01.ec2743be.png";